{
  "topMenu": {
    "dihTitle": "Datenintelligenz-Hub",
    "dihSubTitle": "Sicher Wert aus Daten extrahieren",
    "logout": "Abmelden",
    "dihPortal": "DIH-Portal",
    "cofinityDataspace": "Datenraum-Portal"
  },
  "userLogoutAlert": {
    "title": "Sind Sie sicher, dass Sie sich abmelden möchten?",
    "back": "Zurück",
    "logout": "Abmelden"
  },
  "languages": {
    "en": "English",
    "de": "German (Deutsch)",
    "es": "Spanish (Español)",
    "fr": "French (Français)",
    "zh": "Chinese (中文/简体)",
    "ja": "Japanese (日本語)"
  },
  "sideMenu": {
    "home": "Startseite",
    "collapse": "Seitenleiste einklappen",
    "help": "Hilfe",
    "prepare": "Modell-Management",
    "model": "Datenmodell",
    "mapping": "Daten-Mapping",
    "converter": "Datenkonverter",
    "provide": "Bereitstellen",
    "publishData": "Daten veröffentlichen",
    "assets": "Vermögenswerte",
    "policyPublicationTemplate": "Vorlage für die Veröffentlichung von Richtlinien",
    "uploadHistory": "Verlauf des Hochladens von Assets",
    "consume": "Verbrauchen",
    "searchDataOffers": "Angebote für Suchdaten",
    "negotiatedDataOffers": "Ausgehandelte Datenangebote",
    "downloadHistory": "Verlauf des Asset-Downloads",
    "govern": "Regieren",
    "myPolicies": "Meine Richtlinien",
    "createPolicies": "Richtlinien erstellen",
    "policyTemplate": "Richtlinien-Vorlagen",
    "manageAndConfig": "Konfigurieren",
    "connections": "Konnektoren verwalten",
    "jobs": "Prozessprotokolle",
    "monitoring": "Überwachen",
    "licences": "Lizenzen",
    "providedAgreements": "Bereitgestellte Vertragsvereinbarungen",
    "incomingAgreements": "Angebote für eingehende Daten",
    "consumedAgreements": "Verbrauchte Vertragsvereinbarungen",
    "consumeAutomation": "Automatisierung von Richtlinien nutzen",
    "networkAnalytics": "Netzwerkanalyse",
    "otherLogs": "Andere Protokolle",
    "digitalTwin": "Browser für digitale Zwillinge",
    "messagesBrowserInbound": "Eingehende Nachrichten",
    "messagesBrowserOutbound": "Ausgehende Nachrichten",
    "applications": "Anwendungen",
    "pcfExchange": "PCF-Austausch",
    "pcfRequests": "PCF-Datenanfragen",
    "pcfExchangeHistory": "Historie des PCF-Datenaustauschs",
    "publicationTemplates": "Vorlagen für Publikationen",
    "certificateManagement": "Zertifikatsverwaltung",
    "certificates": "Zertifikate",
    "connectors": "Meine Anschlüsse",
    "contractDefinitions": "Meine Vertragsdefinitionen"
  },
  "versionModal": {
    "title": "Allgemeine Informationen",
    "error": "Fehler beim Abrufen von Versionsdetails",
    "table": {
      "title": "Details zur Komponente",
      "componentName": "Name der Komponente",
      "imageVersion": "Bildversion",
      "chartVersion": "Diagramm-Version"
    }
  },
  "dropdown": {
    "selectAll": "Alles auswählen",
    "noOption": "Keine Optionen verfügbar",
    "noSuchOption": "Eine solche Option gibt es nicht ...",
    "selectConnection": "Eine Verbindung auswählen"
  },
  "certificateManagement": {
    "title": "Verwaltung von Geschäftspartnerzertifikaten",
    "description": "Willkommen bei der benutzerfreundlichen End-to-End-Lösung für den Austausch von Geschäftspartnerzertifikaten in Catena-X.",
    "howTo": {
      "description": "Entdecken Sie den Datenangebot-Katalog anderer Catena-X-Mitgliedsunternehmen. Sie können nach Zertifikatsangeboten suchen, diese auswählen und abonnieren. Die Suche ist auch über den Firmennamen möglich.",
      "doc": "Möchten Sie mehr darüber erfahren, wie die Geschäftspartner-Zertifikatsverwaltung funktioniert? "
    },
    "landingTiles": {
      "tile_1": {
        "title": "Zertifikat veröffentlichen",
        "description": "Erstellen und teilen Sie Ihre Site-Zertifikate im Catena-X-Netzwerk."
      },
      "tile_2": {
        "title": "Zertifikate ermitteln und nutzen",
        "description": "Einfaches Suchen und Herunterladen von Site- und Business-Zertifikaten."
      },
      "tile_3": {
        "title": "Verlauf veröffentlichter Zertifikate",
        "description": "Übersicht über alle von Ihnen bereitgestellten Zertifikate"
      },
      "tile_4": {
        "title": "Verlauf konsumierter Zertifikate",
        "description": "Übersicht über alle von Ihnen genutzten Zertifikate"
      },
      "tile_5": {
        "title": "Eingehende Zertifikatsanfragen",
        "description": "Übersicht der eingehenden Anfragen zum Teilen von Zertifikaten"
      },
      "tile_6": {
        "title": "Status ausgehender Zertifikate",
        "description": "Übersicht über Aktionen zum Teilen von Zertifikaten"
      },
      "tile_7": {
        "title": "Zertifikate anfordern",
        "description": "Einfaches Suchen und Herunterladen von Site- und Business-Zertifikaten."
      }
    },
    "recentCertificateRequests": "Neueste eingehende Zertifikatsdatenanfragen",
    "learnMore": "Erfahren Sie mehr über die Zertifikatsverwaltung",
    "requestCertificates": "Neue Zertifikate anfordern",
    "pushCertificate": "Zertifikat pushen",
    "pushDescription": "Das bestehende Zertifikat wird mit dem unten ausgewählten Partner geteilt. Bitte beachten Sie, dass die gleichen Richtlinien gelten wie im ursprünglichen Angebot. Wenn Sie die Richtlinien ändern möchten, erstellen Sie bitte ein neues Datenangebot.",
    "pushSuccess": "Zertifikats-Pushing-Prozess gestartet! Die Job-ID ist {id}",
    "receiverBpn": "Empfänger BPN",
    "providerBpn": "BPN des Anbieters",
    "locationBpns": "Standort BPNA/BPNS",
    "certificateType": "Typ des Zertifikats",
    "requestSuccess": "Zertifikatsantrag erfolgreich übermittelt!",
    "pushResult": "{successful} von {total} {status} Anfragen erfolgreich",
    "receiveConfirmTitle": "Zertifikatsempfang bestätigen",
    "receiveConfirmDesc": "Durch Klicken auf Ja bestätigen Sie, dass Sie das vom Partner geteilte Zertifikat erhalten haben. Der Anbieter wird Ihre Bestätigung erhalten. Anschließend können Sie das Zertifikat annehmen oder ablehnen.",
    "acceptedConfirmTitle": "Zertifikat akzeptieren",
    "acceptedConfirmDesc": "Durch Klicken auf Ja akzeptieren Sie, dass das Zertifikat den Erwartungen entspricht. Sie können das Zertifikat als PDF herunterladen, indem Sie auf das Ansichtssymbol klicken.",
    "rejectedConfirmTitle": "Zertifikat ablehnen",
    "rejectedConfirmDesc": "Durch Klicken auf Ja lehnen Sie das eingehende Zertifikat ab. Der Anbieter wird über den Ablehnungsstatus informiert. Er kann es erneut teilen oder Sie können ein neues Zertifikat anfordern.",
    "processStarted": "'{type}' Prozess gestartet! Die Job-ID ist {id}",
    "certificateDetails": "Zertifikatsdetails",
    "availableCertificate": "Verfügbare Zertifikatsposition",
    "updateSuccess": "Zertifikat erfolgreich aktualisiert!",
    "updateFailure": "Zertifikat -Update fehlgeschlagen!"
  },
  "schemas": {
    "businessPartnerCertificate": {
      "groups": {
        "basicInfo": "Grundlegende Zertifikatsinformationen",
        "issuer": "Herausgeberinformationen",
        "validity": "Gültigkeitszeitraum",
        "trust": "Vertrauensinformationen",
        "validator": "Validatorinformationen",
        "application": "Anwendungsbereich",
        "enclosedSites": "Eingeschlossene Standorte"
      },
      "fields": {
        "businessPartnerNumber": "Geschäftspartnernummer",
        "registrationNumber": "Registrierungsnummer",
        "certificateType": "Zertifikatstyp",
        "certificateVersion": "Zertifikatsversion",
        "issuerName": "Name des Herausgebers",
        "issuerBpn": "Herausgeber-BPN",
        "validFrom": "Gültig ab",
        "validUntil": "Gültig bis",
        "trustLevel": "Vertrauensstufe",
        "uploaderBpn": "Uploader-BPN",
        "validatorBpn": "Validator-BPN",
        "validatorName": "Validator-Name",
        "areaOfApplication": "Anwendungsbereich",
        "siteBpn": "Standort-BPN",
        "siteAreaOfApplication": "Standort-Anwendungsbereich"
      },
      "tooltips": {
        "basicInfo": "Ein Geschäftspartnerzertifikat beschreibt ein Zertifikat (z.B. ISO9001, IATF-16949) über ein Zertifikatsdokument eines Catena-X-Geschäftspartners",
        "businessPartnerNumber": "Die Geschäftspartnernummer (BPN) der zertifizierten juristischen Person (auf die das Zertifikat ausgestellt ist).",
        "registrationNumber": "Registrierungsnummer des Zertifikats wie auf dem Zertifikat definiert",
        "certificateType": "Art des Zertifikats wie im Dokument definiert, gültige Typen sind beim BPN-Metadatencontroller registriert",
        "certificateVersion": "Version des Zertifikats wie im Dokument definiert, normalerweise die spezifische Version eines Zertifizierungsstandards",
        "issuerName": "Name des Ausstellers, d.h. der Zertifizierungsstelle.",
        "issuerBpn": "Die Geschäftspartnernummer (BPN) des Ausstellers.",
        "validFrom": "Gültig ab Datum wie auf dem Zertifikat definiert.",
        "validUntil": "Gültig bis Datum wie auf dem Zertifikat definiert. Wenn das Zertifikat nie abläuft, sollte der Wert 9999-12-31 sein",
        "trustLevel": "Die Vertrauensstufe des gegebenen Zertifikats - none, low, high, trusted",
        "uploaderBpn": "Die Geschäftspartnernummer (BPN) des Geschäftspartners, der ursprünglich die Zertifikatsdaten oder das Dokument bereitgestellt hat.",
        "validatorBpn": "Die Geschäftspartnernummer (BPN) des Datendienstanbieters, der das gegebene Zertifikat validiert hat",
        "validatorName": "Der optionale Name des Datendienstanbieters, der das gegebene Zertifikat validiert hat",
        "areaOfApplication": "Details zu welchen Bereichen / Anwendungstypen ein Zertifikat für ein Unternehmen und/oder einen Standort gültig ist.",
        "siteBpn": "Die Geschäftspartnernummer (BPNS oder BPNA) eines eingeschlossenen Standorts",
        "siteAreaOfApplication": "Details zu welchen Bereichen / Anwendungstypen ein Zertifikat für ein Unternehmen und/oder einen Standort gültig ist."
      }
    }
  },
  "common": {
    "start": "Start",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "email": "E-Mail-Adresse",
    "phoneNumber": "Telefonnummer",
    "contactPerson": "Ansprechpartner",
    "welcome": "Willkommen",
    "street": "Straße",
    "city": "Stadt",
    "country": "Land",
    "postCode": "Postleitzahl",
    "number": "Anzahl",
    "next": "Weiter",
    "prev": "Zurück",
    "alreadyAccount": "Haben Sie bereits ein Konto?",
    "login": "Anmelden",
    "loginNow": "Jetzt einloggen",
    "register": "Registrieren",
    "home": "Startseite",
    "submit": "Senden",
    "attention": "Achtung",
    "desc": "Beschreibung",
    "website": "Webseite",
    "contact": "Kontakt",
    "details": "Details",
    "plan": "Planen",
    "table": "Tabelle",
    "grid": "Raster",
    "listView": "Listenansicht",
    "gridView": "Raster-Ansicht",
    "firstPage": "Zur ersten Seite",
    "previousPage": "Zur vorherigen Seite",
    "nextPage": "Zur nächsten Seite",
    "lastPage": "Zur letzten Seite",
    "paginationUnknownButton": "Unbekannter Typ der Paginierungsschaltfläche",
    "download": "Herunterladen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "information": "Informationen",
    "organization": "Organisation",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "upload": "Hochladen",
    "link": "Verknüpfung",
    "view": "Ansehen",
    "search": "Suche",
    "searchTerm": "Suche",
    "selectOption": "Wählen Sie eine Option",
    "sortBy": "Sortieren nach",
    "dataspace": "Datenraum",
    "select": "Auswählen",
    "date": "Datum",
    "title": "Titel",
    "back": "Zurück",
    "startTyping": "Beginnen Sie zu tippen",
    "useCases": "Anwendungsfälle",
    "done": "Erledigt",
    "enterValue": "Geben Sie einen Wert ein",
    "selectValue": "Wählen Sie einen Wert aus",
    "selectDate": "Wählen Sie ein Datum",
    "refresh": "Aktualisieren",
    "searchByName": "Suche nach Namen",
    "close": "Schließen",
    "copyToClipboard": "In die Zwischenablage kopiert!",
    "enterKeyName": "Schlüsselname eingeben",
    "fileDownloadSuccess": "Datei erfolgreich heruntergeladen",
    "fileDownloadError": "Dateidownload fehlgeschlagen",
    "certificate": "Zertifikat",
    "manageConnections": "Verbindungen verwalten",
    "confirm": "Bestätigen",
    "yes": "Ja",
    "no": "Nein",
    "connectionDetails": "{type} Verbindungsdetails",
    "hide": "Verstecken",
    "unpublish": "Unveröffentlicht",
    "clear": "Klar"
  },
  "genericError": "Oh, da ist etwas schief gelaufen! Bitte versuchen Sie es erneut.",
  "validation": {
    "fieldRequired": "{field} ist erforderlich.",
    "fieldNumeric": "Das Feld {field} darf nur Zahlen enthalten.",
    "fieldAlpha": "Das Feld {field} darf nur die Buchstaben _ und -.",
    "fieldAlphanumeric": "Das Feld {field} darf nur Buchstaben, Zahlen, _ und -.",
    "fieldNumericDash": "Das Feld {field} darf nur Zahlen und -.",
    "fieldHouseNumber": "Das Feld {field} darf nur Zahlen, Buchstaben und die Zeichen - und /.",
    "fieldPhoneNumber": "Das Feld {field} darf nur Zahlen und - enthalten. Er muss mit + oder 00 beginnen.",
    "fieldAlphaDash": "Das Feld {field} darf nur Buchstaben und -.",
    "exceptHTMLTagBrackets": "Das Feld {field} darf die folgenden Zeichen nicht enthalten: ^<>",
    "isMaxLength": "überschreitet die maximale Länge von 10 Zeichen.",
    "emailFormat": "E-Mail-Adresse hat falsches Format",
    "fileSizeError": "Die Dateigröße ist größer als {size} MB.",
    "csvFileSizeError": "Diese Datei ist zu groß. Sie können Dateien bis zu {size} MB hochladen.",
    "csvFileExtensionError": "Es sind nur Dateien mit der Erweiterung csv erlaubt.",
    "csvFileIsEmptyError": "Diese Datei ist leer. Sie müssen mindestens {size} KB Datei hochladen.",
    "csvFileFormatError": "Die Datei stimmt nicht mit dem erwarteten Format überein. Bitte verwenden Sie die bereitgestellte Vorlage und versuchen Sie es erneut.",
    "uploadFails": "Upload fehlgeschlagen",
    "fileExtensionError": "Die Dateiendung ist nicht geeignet",
    "fileIsMalwareInfectedError": "Diese Datei scheint Malware zu enthalten. Aus Sicherheitsgründen kann diese Datei nicht hochgeladen werden. Bitte überprüfen Sie Ihre Datei erneut",
    "customValidation": "Das {Feld} hat das falsche Format.",
    "selectCountryFirst": "Bitte wählen Sie zuerst den Ländernamen aus",
    "validationPostCodeCaseDE": "Das Feld hat das falsche Format. Es muss 5 Ziffern enthalten, z. B. 53113",
    "validationAlphanumericCase": "Das Feld darf nur alphanumerische Zeichen, Bindestriche und Unterstriche enthalten. Der Wert muss mit einem alphanumerischen Zeichen beginnen.",
    "validationNumericDashCase": "Das Feld darf nur Zahlen und -.",
    "url": "Bitte geben Sie eine gültige URL ein",
    "required": "Dieses Feld ist erforderlich",
    "password": {
      "passwordStrength": "Stärke des Passworts",
      "weak": "Schwach",
      "average": "Durchschnitt",
      "strong": "Stark",
      "passwordValidationMoreChar": "{count} oder mehr Zeichen",
      "passwordUpperAndLowerChar": "Groß- und Kleinbuchstaben",
      "passwordAtLeastNumber": "Mindestens eine Zahl",
      "passwordAtLeastSpecialChar": "Mindestens ein Sonderzeichen (außer <>&\"'[])",
      "passwordDiffFromPrev": "Unterscheidet sich von deinen vorherigen Passwörtern"
    }
  },
  "footer": {
    "tagLine": "Lassen Sie uns eine höhere Leistung erzielen",
    "imprint": "Impressum",
    "imprintShort": "Impressum",
    "imprintLink": "https://dih.telekom.com/en/imprint",
    "contact": "Kontakt",
    "contactLink": "https://dih.telekom.com/en/contact",
    "termsAndConditions": "Allgemeine Geschäftsbedingungen",
    "privacy": "Datenschutzerklärung",
    "privacyShort": "Datenschutzerklärung",
    "telekom": "T-Systems International GmbH. Alle Rechte vorbehalten.",
    "telekomShort": "T-Systems International GmbH",
    "note": "Telekom Data Intelligence Hub - Nur für Geschäftskunden",
    "brandedNote": "Powered by Telekom Data Intelligence Hub",
    "help": "Hilfe",
    "cookieSettings": "Cookie-Einstellungen",
    "cookieSettingsShort": "Kekse",
    "life": "Das Leben ist zum Teilen da"
  },
  "cookieSettings": {
    "collapsedTitle": "Datenschutz-Einstellungen",
    "collapsedText": "Diese Website verwendet Cookies und ähnliche Technologien. Dabei handelt es sich um kleine Textdateien, die auf Ihrem Computer gespeichert und gelesen werden. Indem Sie auf '{0}' klicken, akzeptieren Sie die Verarbeitung, die Erstellung individueller Nutzungsprofile über Websites und Partner hinweg sowie die Übermittlung Ihrer Daten an Dritte, die Ihre Daten teilweise in Ländern außerhalb der Europäischen Union verarbeiten (Art. 49 DSGVO). Einzelheiten finden Sie in Abschnitt 2 der {1}. Die Daten werden für Analysen, Retargeting und für die Ausspielung von personalisierten Inhalten und Werbung auf Telekom-Seiten und Websites Dritter verwendet. Weitere Informationen, u.a. Informationen zur Datenverarbeitung durch Drittanbieter und die Möglichkeit des Widerrufs, finden Sie in den Einstellungen und in unseren Datenschutzhinweisen. Hier können Sie nur mit den notwendigen Werkzeugen {2}.",
    "extendedTitle": "Datenschutz-Einstellungen",
    "extendedText": "Um Ihnen ein optimales Website-Erlebnis zu bieten, verwenden wir Cookies. Dazu gehören Cookies für den Betrieb und die Optimierung der Seite sowie für Dienste wie Text- oder Videochat und für Werbung auf Basis Ihres Online-Nutzungsverhaltens. So können wir z.B. erkennen, ob Sie unsere Seiten wiederholt von demselben Gerät aus besuchen. Wir möchten Ihnen die Wahl lassen, welche Cookies Sie zulassen:",
    "policyLinkHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkCookieHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkTextShort": "Datenschutzinformationen",
    "policyLinkText": "Datenschutzinformationen",
    "rejectLinkText": "fortfahren",
    "acceptButton": "Alle akzeptieren",
    "saveButton": "Einstellungen speichern",
    "settingsButton": "Einstellungen ändern",
    "showMore": "Mehr anzeigen",
    "showLess": "Weniger anzeigen",
    "categoryTitleEssential": "Erforderliche Cookies",
    "categoryTitleAnalytics": "Analytische Cookies",
    "categoryTitleMarketing": "Marketing-Cookies",
    "categoryTitleThirdParty": "Dienstleistungen anderer Unternehmen (unabhängige Drittanbieter)",
    "categoryTextEssential": "Diese Cookies sind erforderlich, um Ihnen die Navigation durch die Websites und die Nutzung wichtiger Funktionen zu ermöglichen. Sie unterstützen grundlegende Funktionen, wie z.B. die Bestellabwicklung im Online-Shop und den Zugriff auf gesicherte Bereiche der Webseite. Sie dienen auch dem Zweck, eine anonymisierte Analyse des Nutzerverhaltens durchzuführen, mit der wir unsere Webseiten für Sie fortlaufend weiterentwickeln und verbessern.",
    "categoryTextAnalytics": "Diese Cookies helfen uns, das Nutzerverhalten besser zu verstehen. Analyse-Cookies ermöglichen die Zusammenstellung von Nutzungs- und Identifikationsdaten durch den Originalanbieter oder Drittanbieter zu pseudonymen Nutzungsprofilen. Wir verwenden Analyse-Cookies z.B., um die Anzahl der einzelnen Besucher einer Webseite oder eines Dienstes zu ermitteln, statistische Daten über die Leistung unserer Produkte zu sammeln und das Nutzungsverhalten und die Besucherinteraktionen der Besucher auf der Grundlage anonymer und pseudonymer Informationen zu analysieren. Diese Informationen können nicht auf eine Person zurückgeführt werden.",
    "categoryTextMarketing": "Diese Cookies und ähnliche Technologien werden verwendet, um die Anzeige personalisierter und damit relevanter Marketinginhalte zu ermöglichen. Marketing-Cookies werden verwendet, um interessante Werbeinhalte anzuzeigen und die Wirksamkeit unserer Kampagnen zu messen. Dies geschieht nicht nur auf den Webseiten der Telekom, sondern auch auf anderen Seiten der Werbepartner (Drittanbieter). Dies wird auch als Retargeting bezeichnet. Sie wird verwendet, um pseudonyme Inhalte oder Anzeigenprofile zu erstellen, relevante Werbung auf anderen Websites zu schalten und um Erkenntnisse über Zielgruppen abzuleiten, die sich die Anzeigen und Inhalte angesehen haben. Diese Informationen können nicht auf eine Person zurückgeführt werden. Marketing- und Retargeting-Tools unterstützen uns dabei, Ihnen Werbeinhalte zu liefern, die möglicherweise für Sie relevant sind. Durch die Unterdrückung von Marketing-Cookies sehen Sie immer noch die gleiche Menge an Werbung, die jedoch für Sie möglicherweise weniger relevant ist.",
    "categoryTextThirdParty": "Die Webseiten der Telekom enthalten Links zu Drittanbietern, die ihre Dienste in eigener Verantwortung erbringen. Wenn Sie die Webseiten der Telekom besuchen, erfassen Cookies oder ähnliche Technologien Daten und senden sie an Dritte, zum Teil für eigene Zwecke der Telekom. Umfang, Zweck und Rechtsgrundlage für die weitere Verarbeitung zu eigenen Zwecken des Dritten entnehmen Sie bitte den Datenschutzhinweisen des Drittanbieters. Informationen zu den unabhängigen Drittanbietern finden Sie in den Datenschutzhinweisen."
  },
  "messages": {
    "noDataAvailable": "Keine Daten verfügbar",
    "noMatchFound": "Keine Übereinstimmung gefunden",
    "maximumFileSize": "Maximale Dateigröße",
    "suitableFileFormats": "Geeignete Dateiformate",
    "loading": "Wird geladen...",
    "dragDropText": "oder ziehen Sie es hierher und ziehen Sie es dort ab",
    "noConnectors": "Keine Konnektoren gefunden!",
    "comingSoon": "Demnächst verfügbar"
  },
  "pageNotFound": {
    "title": "Hoppla! Sieht so aus, als ob die Seite, die Sie suchen, noch nicht existiert.",
    "subtitle": "Schauen Sie sich in der Zwischenzeit unsere anderen Ressourcen an, die für Sie hilfreich sein könnten!"
  },
  "helpResources": {
    "needHelp": "Benötigen Sie Hilfe bei der Suche nach dem richtigen Plan, weitere Informationen, technische Fragen?",
    "developerDoc": "Dokumentation des Integrators",
    "developerDocDesc": "API-Dokumentation abrufen, um loszulegen",
    "example": "Beispiel",
    "tutorials": "Anleitungen",
    "exampleDescription": "Finden Sie Anwendungsfälle und Demos, die für Ihre Branche relevant sind",
    "FAQ": "Häufig gestellte Fragen",
    "FAQDescription": "Finden Sie gängigere Antworten von der Abrechnung bis zum Datenschutz",
    "browse": "Durchsuchen",
    "demos": "Demos",
    "demosDescription": "Finden Sie Anwendungsfälle und Demos, die für Ihre Branche relevant sind",
    "glossary": "Glossar",
    "glossaryDescription": "Hier finden Sie die Begriffe und Definitionen im Zusammenhang mit Data Intelligence Hub, IDSA, Catena-X, Gaia-X und mehr.",
    "contactUs": "Diese Funktion wird in Ihrem aktuellen Abonnement nicht unterstützt. Bitte kontaktieren Sie uns, um ein Upgrade durchzuführen."
  },
  "feedbackCard": {
    "title": "Benötigen Sie weitere Hilfe?",
    "contactUs": "Kontaktiere uns"
  },
  "error": {
    "pageNotFound": "Seite nicht gefunden (404)",
    "somethingWrong": "Etwas ist schief gelaufen!",
    "propertyNotFound": "Eigenschaft nicht gefunden",
    "uniquePropertyName": "Der Name der Eigenschaft muss eindeutig sein",
    "dctTypeNotFound": "dct:type nicht gefunden"
  },
  "helpWidget": {
    "askSupport": "Support fragen",
    "chatboxTitle": "Hilfe chat",
    "chatboxSubtitle": "Telekom Data Intelligence Hub Unterstützung",
    "defaultMessage": {
      "body": "Hallo, willkommen im Support-Kanal des Telekom Data Intelligence Hub. Bitte wählen Sie unten eine Option aus."
    },
    "whatCanWeHelpWith": "Womit können wir Ihnen heute helfen?",
    "suggestedAnswers": {
      "knowledgeBase": "Wissensdatenbank, Dokumentation und FAQs",
      "contactSupport": "Support kontaktieren",
      "contactSales": "Vertrieb kontaktieren"
    }
  },
  "pcfExchange": {
    "title": "PCF-Börse",
    "description": "Willkommen bei der einfach zu bedienenden End-to-End-Lösung für den Austausch von Product Carbon Footprint (PCF) in Catena-X.",
    "recentRequests": "Kürzliche PCF-Datenanfragen",
    "viewAllRequests": "Alle Anfragen anzeigen",
    "requestPcf": "PCF anfordern",
    "termCheck": "Mit dem Absenden der Anfrage verstehe ich, dass der Vertrag über das Datenangebot gemäß den vom Datenanbieter festgelegten Richtlinien ausgehandelt wird.",
    "pcfSuccess": "PCF erfolgreich angefordert!",
    "landing": {
      "pcfTitle": "PCF-Angebot erstellen",
      "pcfDesc": "Erstellen Sie die PCF-Daten und teilen Sie sie mit den Teilnehmern des Catena-X-Netzwerks.",
      "discoverTitle": "PCF-Daten entdecken und anfordern",
      "discoverDesc": "Suchen Sie ganz einfach PCF-Daten im Catena-X-Netzwerk oder fordern Sie die PCF-Daten in wenigen Schritten bei Ihren Partnern an.",
      "pcfReqTitle": "PCF-Datenanfragen",
      "pcfReqDesc": "Verwalten Sie effizient die PCF-Datenanfragen Ihrer Partner im Catena-X-Netzwerk.",
      "pcfCalcTitle": "PCF-Rechner",
      "pcfCalcDesc": "Berechnen Sie die PCF-Werte und verbinden Sie sich nahtlos mit Ihren Anwendungen oder PCF-Datenaustauschszenarien.",
      "pcfHistoryTitle": "Verlauf des PCF-Datenaustauschs",
      "pcfHistoryDesc": "Gewinnen Sie Transparenz über Ihre PCF-Datenaustauschhistorie im Catena_X Netzwerk und bei Ihren Partnern.",
      "documentation": "Erfahren Sie mehr über den PCF-Datenaustausch",
      "howTo": {
        "description": "Teilen, entdecken und verwalten Sie den Product Carbon Footprint (PCF), den die Daten bieten. Catena-X.",
        "doc": "Möchten Sie mehr über Connect & Integrate erfahren? Link zur Dokumentation: "
      }
    },
    "requests": {
      "pcfRequests": "PCF-Datenanfragen",
      "reqDesc": "Nutzen Sie den Bereich, um Ihre PCF-Datenanfragen von Partnern zu verwalten.",
      "productId": "Produkt-ID*",
      "bpn": "BPN*",
      "message": "Nachricht",
      "howTo": {
        "title": "Möchten Sie mehr über die Arbeit des PCF-Datenanforderungsmanagements erfahren?",
        "description": "Nutzen Sie diesen Abschnitt, um die PCF-Datenanfrage Ihrer Partner zu genehmigen oder abzulehnen. Darüber hinaus können Sie den Status des pcf-Datenaustauschs einsehen und volle Transparenz in Ihrer PCF-Datenkette erhalten.",
        "doc": "Möchten Sie mehr darüber erfahren, wie Datenangebot, Verhandlung und Konsum funktionieren?"
      }
    },
    "responses": {
      "howTo": {
        "description": " Entdecken Sie den Datenangebotskatalog anderer Catena-X-Mitgliedsunternehmen. Sie können ein Datenangebot suchen, auswählen und abonnieren. Sie können nach Datenangeboten über den Firmennamen oder mit der Manufacturer Part ID oder mit einer Kombination aus zwei suchen."
      }
    },
    "view": {
      "title": "PCF-Details anzeigen"
    }
  },
  "publicationTemplates": {
    "title": "Meine Publikationsvorlagen",
    "deletedTemplates": "Meine gelöschten Vorlagen",
    "showDeletedTemplates": "Gelöschte Vorlagen anzeigen",
    "hideDeletedTemplates": "Aktive Vorlagen anzeigen",
    "newTemplate": "Neue Vorlage",
    "create": {
      "title": "Publikationsvorlage erstellen",
      "edit": "Publikationsvorlage bearbeiten",
      "templateName": "Name der Vorlage",
      "templateType": "{Typ} Vorlage",
      "create": "Erstellen",
      "update": "Aktualisieren",
      "name": "Name",
      "createdAt": "Erstellt am",
      "modifiedAt": "Geändert am",
      "country": "Land",
      "accessPolicyId": "Zugriffsrichtlinie",
      "usagePolicyId": "Nutzungsrichtlinie",
      "id": "Ausweis",
      "createdBy": "Erstellt von",
      "modifiedBy": "Geändert von",
      "isEnabled": "Ist aktiviert",
      "targetCompany": "Zielunternehmen",
      "targetConnectors": "Ziel-Konnektoren",
      "selectCountry": "Wählen Sie ein Land aus",
      "templateDetails": "Details zur Veröffentlichungsvorlage",
      "assetsCriteria": "Kriterien für die Auswahl von Vermögenswerten",
      "connectorDetails": "Details zum Konnektor"
    },
    "delete": {
      "title": "Veröffentlichungsvorlage löschen",
      "description": "Sind Sie sicher, dass Sie diese Vorlage löschen möchten?",
      "button": "Löschen"
    }
  },
  "contracts": {
    "title": "Details zu Vertragsvereinbarungen",
    "provider": {
      "description": "Dies ist eine Übersicht über Vertragsvereinbarungen, die Ihre Organisation mit anderen Datenraum-Teilnehmern hat.",
      "howItWorks": {
        "description": "Hier finden Sie alle Ihre abonnierten oder ausgehandelten Datenvereinbarungen über verschiedene Datenräume hinweg. Sie können die Ergebnisse nach einem bestimmten Konnektor filtern oder einfach mit einer Vertragsvereinbarungs-ID oder einer Asset-ID suchen. Sie können die Liste auch sortieren, um Datenvereinbarungen basierend auf Ihren Anforderungen anzuzeigen. Des Weiteren können Sie die Datenangebote auswählen und auf Wunsch lokal exportieren.",
        "subtitle": "Möchten Sie mehr darüber erfahren, wie Datenangebot, Verhandlung und Konsum funktionieren?"
      },
      "details": {
        "title": "Details zu den bereitgestellten Vertragsvereinbarungen",
        "description": "Beschreibung",
        "content": "Inhalt",
        "agreementDetails": "Details zur Vereinbarung",
        "assetDetails": "Details zum Asset",
        "usagePolicy": "Nutzungsrichtlinie"
      }
    },
    "consumer": {
      "description": "Dies ist eine Übersicht über Vertragsvereinbarungen, die Ihre Organisation für Datenangebote anderer Datenraum-Teilnehmer hat",
      "downloadData": "Daten herunterladen",
      "downloadAgreement": "Vereinbarung herunterladen",
      "reinitiate": "Übertragung & Download von Daten starten",
      "error": {
        "heading": "Entschuldigung! Sieht so aus, als hättet Ihr diesen Vertrag bereits ausgehandelt.",
        "body": "Sie können einen bereits ausgehandelten Vertrag nicht neu verhandeln. Sie können die Vertragsdetails finden und diese Vereinbarung herunterladen und Daten abonnieren."
      },
      "details": {
        "title": "Details zu verbrauchten Vertragsvereinbarungen"
      },
      "howItWorks": {
        "description": "Hier finden Sie alle Ihre abonnierten oder ausgehandelten Datenvereinbarungen über verschiedene Datenräume hinweg. Sie können die Ergebnisse nach einem bestimmten Konnektor filtern oder einfach mit einer Vertragsvereinbarungs-ID oder einer Asset-ID suchen. Sie können die Liste auch sortieren, um Datenvereinbarungen basierend auf Ihren Anforderungen anzuzeigen. Des Weiteren können Sie die Datenangebote auswählen und auf Wunsch lokal exportieren.",
        "subtitle": "Möchten Sie mehr darüber erfahren, wie Datenangebot, Verhandlung und Konsum funktionieren?"
      }
    }
  },
  "provider": {
    "provider": "Anbieter",
    "assets": {
      "title": "Mein Vermögen",
      "offeredBy": "Angeboten von:",
      "offers": "Angebote",
      "created": "Erstellt",
      "modifiedAt": "Geändert am",
      "noResultsFound": "Es wurden keine Assets gefunden",
      "success": "Asset erfolgreich erstellt",
      "updateSuccess": "Asset erfolgreich aktualisiert",
      "buttons": {
        "createOffer": "Angebot erstellen",
        "details": "Details anzeigen",
        "delete": "Asset löschen",
        "create": "Asset erstellen",
        "close": "Schließen",
        "edit": "Asset bearbeiten",
        "update": "Asset aktualisieren",
        "showDeleted": "Gelöschte Assets anzeigen",
        "hideDeleted": "Gelöschte Assets ausblenden",
        "restore": "Asset wiederherstellen",
        "save": "Speichern",
        "add": "Schlüssel-Wert-Paar hinzufügen",
        "addJson": "JSON-Objekt hinzufügen",
        "editJson": "JSON-Objekt bearbeiten",
        "saveJson": "JSON speichern",
        "advanceAddition": "Erweiterte Ergänzung",
        "unpublish": "Unveröffentlichtes Gut",
        "showAssets": "Vermögen zeigen"
      },
      "detailsDialog": {
        "title": "Details zum Asset"
      },
      "createDialog": {
        "title": {
          "general": "Neues Asset erstellen",
          "edit": "Asset bearbeiten",
          "addProperties": "Eigenschaften hinzufügen",
          "advance": "Erweiterte Ergänzung der Eigenschaft"
        },
        "publicProps": "Öffentliches Eigentum",
        "privateProps": "Private Immobilien",
        "dataAddress": "Datenadresse",
        "dataSources": "Datenquelle",
        "dataDestination": "Ziel der Daten",
        "json": {
          "fields": "Json-Felder",
          "editor": "Editor für benutzerdefinierte Eigenschaften",
          "formatted": "Viewer für benutzerdefinierte Eigenschaften",
          "error": "Ungültiges JSON:"
        },
        "connectionTypeLabel": {
          "http": "Geben Sie die URL ein",
          "s3": "Geben Sie den Objektnamen ein",
          "azure": "Geben Sie den Namen des Blobs ein.",
          "sftp": "Geben Sie den Dateinamen ein"
        },
        "fields": {
          "name": "Name",
          "namePlaceholder": "Geben Sie den Namen des Angebots ein",
          "id": "Ausweis",
          "description": "Beschreibung",
          "contenttype": "Inhaltstyp",
          "contenttypePlaceholder": "Inhaltstyp eingeben",
          "contentType": "Inhaltstyp",
          "contentTypePlaceholder": "Inhaltstyp eingeben",
          "version": "Version",
          "keywords": "Schlüsselwörter",
          "language": "Sprache",
          "languagePlaceholder": "Sprache auswählen",
          "semanticId": "Semantische ID",
          "semanticIdPlaceholder": "Bitte fügen Sie die sematische ID ein",
          "dct:type": "dct:type",
          "dct:typePlaceholder": "Wählen Sie einen dct-Typ",
          "keywordsPlaceholder": "Schlüsselwörter hinzufügen",
          "descriptionPlaceholder": "Schreibe die Angebotsbeschreibung",
          "versionPlaceholder": "Versionsnummer",
          "dataType": "Typ der Datenadresse",
          "dataTypePlaceholder": "Datentyp der Datenadresse auswählen",
          "dataAddressUrl": "Asset-URL",
          "dataAddressUrlPlaceholder": "Geben Sie die Asset-URL ein",
          "targetCompany": "Zielunternehmen",
          "targetCompanyPlaceholder": "Fügen Sie eine Zielfirma ein",
          "country": "Land",
          "countryPlaceholder": "Ein Land einfügen",
          "key": "Schlüssel",
          "keyPlaceholder": "Geben Sie den Schlüssel ein",
          "value": "Wert",
          "valuePlaceholder": "Geben Sie den Wert ein",
          "assetType": "Asset-Typ",
          "assetTypePlaceholder": "Asset-Typ eingeben"
        },
        "validation": {
          "name": "Bitte geben Sie einen Namen ein",
          "assetType": "Bitte wählen Sie einen Asset-Typ aus",
          "contentType": "Bitte geben Sie einen gültigen Inhaltstyp ein",
          "dataType": "Bitte wählen Sie einen gültigen Datentyp aus",
          "targetCompany": "Bitte geben Sie eine gültige Zielfirma ein",
          "country": "Bitte geben Sie ein gültiges Land ein"
        }
      },
      "tags": {
        "restricted": "Zugang eingeschränkt",
        "unrestricted": "Uneingeschränkt"
      },
      "search": {
        "title": "Suchfilter",
        "helperText": "Suche nach Asset-Name, Erstellungsdatum oder -typ",
        "filters": {
          "byName": "Name des Assets",
          "byType": "Asset-Typ",
          "byDate": "Änderungsdatum"
        }
      },
      "delete": {
        "title": "Asset löschen",
        "description": "Sind Sie sicher, dass Sie dieses Asset löschen möchten?"
      },
      "unpublish": {
        "title": "Unveröffentlichtes Gut",
        "description": "Sind Sie sicher, dass Sie dieses Gut unveröffentlicht haben möchten?"
      }
    },
    "fileUploadTerms": "Ich verstehe und bestätige, dass ich alle erforderlichen Informationen korrekt ausgefüllt habe und T-Systems nicht haftbar gemacht werden kann, wenn falsche Angaben gemacht werden und Angebote abgelehnt werden.",
    "fileUploadInfo": "T-Systems prüft nicht die Gültigkeit der hier eingegebenen Metadaten-Informationen. Bitte stellen Sie sicher, dass Sie die richtigen und vollständigen Angaben gemacht haben.",
    "pdf": "PDF",
    "csv": "CSV",
    "singleEntry": "Einfacher Eintrag",
    "bulkEntries": "Bulk-Einträge"
  },
  "home": {
    "title": "Verbinden & Integrieren"
  },
  "gettingStarted": {
    "title": "Benötigen Sie Hilfe beim Einstieg?",
    "openWizard": "Assistent öffnen",
    "yourDataOffering": "Ihr Datenangebot",
    "yourAssets": "Vermögenswerte",
    "yourPolicies": "Meine Richtlinien",
    "preconfiguredCatalogue": "Vorkonfigurierter Katalog",
    "contractAgreements": "Vertragsvereinbarungen",
    "incomingAgreements": "Eingehende Vereinbarungen",
    "outgoingAgreements": "Ausgehende Vereinbarungen",
    "connectors": "Ihre Konnektoren",
    "providedAgreements": "Bereitgestellte Vertragsvereinbarungen",
    "consumedAgreements": "Verbrauchte Vertragsvereinbarungen"
  },
  "yourConnection": {
    "title": "Ihre Konnektoren",
    "viewAllConnection": "Alle Konnektoren anzeigen",
    "help": "Hilfe",
    "documentation": "Lernen Sie Ihr Connect & Integrate kennen",
    "gettingStarted": "Leitfaden für die ersten Schritte",
    "noUseCases": "Keine Anwendungsfälle verfügbar"
  },
  "wizardSelectionPopup": {
    "whatToLike": "Was möchtest du heute machen?",
    "prepare": "Vorbereiten",
    "govern": "Regieren",
    "provide": "Bereitstellen",
    "consume": "Verbrauchen",
    "howToProvide": "Wie möchten Sie heute Daten bereitstellen?",
    "manual": "Manuell",
    "automated": "automatisiert über eine API",
    "selectUseCases": "Wählen Sie Ihr(e) Anwendungsfall(e)",
    "selectSingleUseCase": "Wählen Sie Ihren Anwendungsfall aus",
    "selectDigitalTwin": "Wählen Sie den Typ Ihres digitalen Zwillings aus",
    "back": "Zurück",
    "next": "Weiter",
    "publish": "Ich verstehe die Framework-Anforderungen des Dataspace und stimme zu, das Datenangebot im Namen meiner Organisation im Dataspace zu veröffentlichen."
  },
  "createOffer": {
    "title": {
      "standard": "Datenangebot erstellen",
      "pcf": "PCF-Datenangebot erstellen",
      "certificate": "Zertifikatsangebot erstellen"
    },
    "publish": "Veröffentlichen",
    "legalConfirmation": "Ich verstehe die Rahmenbedingungen des Datenraums und bin damit einverstanden, das Datenangebot im Namen meiner Organisation im Datenraum zu veröffentlichen.",
    "wizard": {
      "provisionAsset": "Rückstellungsvermögen",
      "dataUpload": "Auswahl der Daten",
      "attachPolicy": "Richtlinie anhängen",
      "publishDataOffer": "Datenangebot veröffentlichen"
    },
    "provisionAsset": {
      "howToSelectSubmodel": "Für welches Teilmodell möchten Sie ein Datenangebot erstellen?",
      "selectSubmodel": "Untermodell auswählen",
      "selectUsecase": "Wählen Sie einen Anwendungsfall aus",
      "selectDigitalTwinType": "Wählen Sie einen digitalen Zwillingstyp aus",
      "whichTypeToSelect": "Welchen Typ soll ich auswählen?",
      "generalInformation": "Allgemeine Informationen",
      "name": "Name",
      "id": "Ausweis",
      "description": "Beschreibung",
      "contentType": "Inhaltstyp",
      "version": "Version",
      "keywords": "Schlüsselwörter",
      "language": "Sprache",
      "location": {
        "title": "Ort und Adresse",
        "text": "Bitte geben Sie die Details Ihres Assets ein"
      },
      "username": "Benutzername",
      "password": "Passwort",
      "assetUrl": "Asset-URL",
      "assetUrlPlaceHolder": "Bitte geben Sie Ihre Asset-URL ein",
      "clientId": "Kunden-ID",
      "clientSecret": "Geheimer Client",
      "tokenUrl": "Token-URL",
      "tokenUrlPlaceHolder": "Bitte fügen Sie Ihre Token-URL ein",
      "provideAssets": "Ressource bereitstellen",
      "selectConnectorLabel": "Wählen Sie aus, mit welchem(n) Konnektor(en) Sie Ihre Daten teilen möchten",
      "selectConnectorPlaceholder": "Wählen Sie einen Verbinder aus",
      "selectRestApiType": "REST-API-Typ auswählen",
      "selectedAuthMethod": "Authentifizierungsmethode"
    },
    "dataUpload": {
      "selectedDataModel": "Wählen Sie Ihre Daten aus",
      "csvUpload": {
        "title": "CSV-Datei",
        "description": "Ziehen Sie Ihre Dateien hierher oder laden Sie sie hoch",
        "uploadFile": "Datei auswählen",
        "uploadFileDescription": "Bereite die Datei vor und lade sie hoch, die du austauschen möchtest. Sie können die Beispieldatei herunterladen, um Ihnen den Einstieg in das für Catena-X erforderliche Format zu erleichtern.",
        "uploadFileDescriptionNote1": "Laden Sie die Vorlagendatei über den untenstehenden Link herunter",
        "uploadFileDescriptionNote2": "Füllen Sie die bereitgestellte Datei mit Details zu Ihren Partnern aus",
        "uploadFileDescriptionNote3": "Laden Sie die Datei im dafür vorgesehenen Bereich hoch",
        "partnerValidationNote": "Wenn Sie mehr über die Partnervalidierung erfahren möchten, bitte",
        "clickHere": "hier klicken",
        "downloadTemplate": "Vorlage herunterladen",
        "downloadSampleCsv": "Beispiel-CSV herunterladen",
        "supportedFileTypes": "Unterstützte Dateitypen:"
      },
      "jsonUpload": {
        "title": "json",
        "description": "Schreiben Sie Ihren eigenen JSON-Code"
      },
      "tableUpload": {
        "title": "Tabelle",
        "description": "Eigene Tabelleneinträge bereitstellen",
        "add": "Hinzufügen"
      },
      "fileUpload": {
        "title": "Datei hochladen",
        "description": "csv, json"
      },
      "objectStorage": {
        "title": "Objektspeicher",
        "description": "AWS, Azure, OTC oder GCP"
      },
      "sftp": {
        "title": "SFTP-Server",
        "description": "Übertragung per SFTP"
      },
      "apiUpload": {
        "title": "REST-API",
        "description": "Übertragung über API",
        "authAndIdentiTitle": "Authentifizierung und Identifikation",
        "authAndIdentiDesc": "Bitte geben Sie die Authentifizierungsdaten Ihres Zielsystems ein",
        "selectApiType": "REST-API-Typ auswählen",
        "locationAndAddrTitle": "Standort und Adressierung",
        "locationAndAddrDesc": "Bitte geben Sie die Details Ihres Assets ein",
        "assetUrl": "Objekt-URL",
        "username": "Benutzername",
        "password": "Passwort",
        "clientId": "Kunden-ID",
        "clientSecret": "Geheimer Client-Schlüssel"
      }
    },
    "fileUpload": {
      "title": "Ziehen Sie Ihre Datei hierher und legen Sie sie dort ab",
      "btnText": "Datei auswählen"
    },
    "attachPolicy": {
      "title": "Füge eine Richtlinie zu diesem Datenangebot hinzu",
      "createPolicy": "Erstellen einer neuen Richtlinie",
      "bpnFieldTitle": "Mit wem möchten Sie Ihre Daten austauschen?",
      "howItWork": {
        "title": "Wie funktioniert es?",
        "description": "Wir konfigurieren die Policies auf Basis des Catena-X Use Case Rahmenvertrags vor. Der Zugriff auf Ihre Daten ist nur für die angegebenen Geschäftspartnernummern gestattet.",
        "knowMore": "Möchten Sie mehr über die Richtlinien erfahren?",
        "documentation": "Dokumentation"
      },
      "accessPolicyTableText": "Füge eine Zugriffsrichtlinie an dieses Datenangebot an",
      "usagePolicyTableText": "Fügen Sie diesem Datenangebot eine Nutzungsrichtlinie hinzu",
      "heading": {
        "title": "Vorhandene Richtlinien anhängen oder neue erstellen",
        "description": "Bitte fügen Sie sowohl die Zugriffs- als auch die Nutzungsrichtlinie aus den folgenden Tabellen bei, um die Veröffentlichung des Datenangebots abzuschließen. Sie können auch nach Richtlinien mit Richtliniennamen suchen oder eine neue Richtlinie erstellen, falls Sie noch nicht über eine gewünschte Richtlinie verfügen."
      }
    },
    "publishDataOffer": {
      "dataOfferDetails": "Details zum Datenangebot",
      "generalInformation": "Allgemeine Informationen",
      "attribute": "Attribut",
      "value": "Wert",
      "knowMore": "Erfahren Sie mehr über Ihr Datenangebot",
      "attachedDataAssets": "Angehängte Elemente",
      "attachedPolicies": "Angehängte Richtlinien",
      "allowPolicyPublish": "Ich erlaube die Veröffentlichung von Richtlinien",
      "publish": "Veröffentlichen",
      "verifiedLegalEntity": "Verifizierte juristische Person von",
      "dataOfferCreatedBy": "Datenangebot erstellt von: ",
      "contactOrgAdmin": "Kontakt zum Organisationsadministrator",
      "help": "Hilfe",
      "attachedDataAsset": "Angehängtes Datenasset",
      "attachedAccessPolicy": "Richtlinie für den angefügten Zugriff",
      "attachedUsagePolicy": "Angehängte Nutzungsrichtlinie",
      "publishedConnectors": "Konnektoren, für die dieses Angebot veröffentlicht wird",
      "knowMoreConnector": "Erfahren Sie mehr über Ihre Konnektoren",
      "knowMorePolicies": "Erfahren Sie mehr über Ihre Richtlinien",
      "knowMoreDataAssets": "Erfahren Sie mehr über Ihre Datenbestände",
      "knowMoreDataOffers": "Erfahren Sie mehr über Ihr Datenangebot",
      "publishCheckboxLabel": "Ich stimme im Namen meiner Organisation zu, das Datenangebot und die Assets im Datenbereich zu veröffentlichen. Ich bestätige die Verwendung der zugehörigen Richtlinien zur Steuerung des Datenraums und der zugehörigen Richtlinien und werde den Rahmen des Datenraums für alle Vorgänge auf dem Angebot und den Assets befolgen, sobald sie veröffentlicht sind."
    },
    "result": {
      "success": {
        "title": "Erfolgreiche Anforderung.",
        "description": "Asset-Publishing-Prozess gestartet! Die Job-ID ist {id}"
      }
    },
    "success": {
      "title": "Ihr Datenangebot ist nun veröffentlicht",
      "description": "Ihr Datenangebot ist nun veröffentlicht, klicken Sie auf folgendes für die nächsten Schritte",
      "createOffer": "Ein weiteres Datenangebot erstellen",
      "createOfferButton": "Erstellen",
      "goToHome": "Zur Startseite",
      "goToHomeButton": "Zur Startseite",
      "uploadHistory": "Überprüfe deinen Upload-Verlauf"
    }
  },
  "policy": {
    "newPolicy": "Neue Richtlinie",
    "showDeletedPolicies": "Gelöschte Richtlinien anzeigen",
    "myDeletedPolicies": "Meine gelöschten Richtlinien",
    "hideDeletedPolicies": "Aktive Richtlinien anzeigen",
    "restoreAsset": "Wiederherstellen",
    "publishDeletion": "Löschen veröffentlichen",
    "create": {
      "title": "Neue Richtlinie erstellen",
      "edit": "Richtlinie bearbeiten",
      "policyName": "Name der Richtlinie",
      "policyType": "{Typ} Richtlinie",
      "accessPolicy": "Zugriffsrichtlinie",
      "usagePolicy": "Nutzungsrichtlinie",
      "create": "Erstellen und speichern",
      "update": "Aktualisieren"
    },
    "delete": {
      "title": "Richtlinie löschen",
      "description": "Sind Sie sicher, dass Sie diese Richtlinie löschen möchten?",
      "button": "Löschen"
    },
    "types": {
      "BusinessPartnerNumber": {
        "title": "Geschäftspartnernummer",
        "description": "Die Geschäftspartnernummer-Beschränkung kann verwendet werden, um festzulegen, welche genauen Geschäftspartner (basierend auf BPNL) das jeweilige Datenangebot einsehen oder darüber verhandeln dürfen. Bitte stellen Sie sicher, dass Sie mindestens eine 16-stellige BPNL-Nummer im rightOperand hinzufügen; Wildcards werden nicht unterstützt."
      },
      "BusinessPartnerGroup": {
        "title": "Geschäftspartnergruppe",
        "description": "Die Geschäftspartnergruppen-Beschränkung kann verwendet werden, um festzulegen, welche genauen Geschäftspartner (basierend auf BPNL) das jeweilige Datenangebot einsehen oder darüber verhandeln dürfen. z.B. BusinessPartnerWithoutBilateralContract."
      },
      "Membership": {
        "title": "Mitgliedschaft",
        "description": "Das Mitgliedschafts-Credential kann verwendet werden, um sicherzustellen, dass nur CX-Mitglieder das jeweilige Datenangebot einsehen oder darüber verhandeln dürfen."
      },
      "ContractReference": {
        "title": "Vertragsreferenz",
        "description": "Die Vertragsreferenz-Beschränkung kann verwendet werden, um zu definieren, unter welchen bilateralen Vertragsdetails die Daten geteilt werden. Beachten Sie, dass der genaue bilaterale Vertragsname im rechten Operanden hinzugefügt werden muss."
      },
      "Dismantler.allowedBrands": {
        "title": "Demonteur Erlaubte Marken",
        "description": "Unternehmensrolle, die einen Demonteur definiert. Unternehmen, die das Credential besitzen, sind zertifizierte Demonteur-Unternehmen."
      },
      "UsagePurpose": {
        "title": "Nutzungszweck",
        "description": "Nutzungszweck"
      },
      "FrameworkAgreement": {
        "title": "Rahmenvereinbarung",
        "description": "Mit dem FrameworkAgreement-Credential dürfen nur die Teilnehmer das jeweilige Datenangebot einsehen oder darüber verhandeln, die die entsprechende Rahmenvereinbarung (allgemein oder über eine bestimmte Version) unterzeichnet haben."
      },
      "Dismantler": {
        "title": "Demonteur",
        "description": "Unternehmen, die das Credential besitzen, sind zertifizierte Demonteur-Unternehmen.",
        "allowedBrands": {
          "title": "Demonteur Erlaubte Marken",
          "description": "Unternehmensrolle, die einen Demonteur definiert. Unternehmen, die das Credential besitzen, sind zertifizierte Demonteur-Unternehmen."
        }
      },
      "Duration": {
        "title": "Dauer",
        "description": "Dauer für die Datennutzung ab Unterzeichnungsdatum."
      },
      "inForceDate": {
        "title": "Fester Datumsbereich",
        "description": "Fester Datums-/Zeitrahmen für die Datennutzung."
      },
      "connector": {
        "title": "Konnektor-Beschränkung",
        "description": "Unternehmen, die die Konnektoren für ihre Beschränkung verwenden."
      }
    },
    "fields": {
      "BusinessPartnerNumber": "Geschäftspartnernummer",
      "tx:BusinessPartnerGroup": "Geschäftspartnergruppe",
      "cx-policy:Membership": "Mitgliedschaft",
      "cx-policy:ContractReference": "Vertragsreferenz",
      "cx-policy:Dismantler.allowedBrands": "Demonteur Erlaubte Marken",
      "cx-policy:UsagePurpose": "Nutzungszweck",
      "cx-policy:FrameworkAgreement": "Rahmenvereinbarung",
      "cx-policy:Dismantler": {},
      "duration": "Dauer",
      "unit": "Einheit",
      "fromdate": "Von Datum",
      "todate": "Bis Datum",
      "connector": "Konnektor"
    }
  },
  "jobs": {
    "jobs": "Jobs",
    "id": "Id",
    "name": "Name",
    "startedAt": "Gestartet am",
    "status": "Status",
    "duration": "Dauer",
    "action": "Aktionen",
    "jobDetails": "Details zum Prozess",
    "reload": "Neu laden",
    "noDetailsAvailable": "Für diesen Job sind keine weiteren Details verfügbar",
    "retry": "Wiederaufsetzen"
  },
  "search-offer": {
    "pageTitle": "Angebote für Suchdaten",
    "pcfTitle": "Suche nach PCF-Datenangeboten",
    "certificateTitle": "Suche nach Zertifikatsangeboten für Geschäftspartner",
    "filter": {
      "bpnSearch": "Suche nach Ihrer Geschäftspartnernummer oder einem Firmennamen",
      "bpnSearchNote": "Finden Sie die Datenangebote, indem Sie mit dem Firmennamen oder BPN suchen.",
      "manufacturePartId": "Hersteller-Teile-ID",
      "manufacturePartIdNote": "Sucht nach allen Datenangeboten, die zur angegebenen Teile-ID passen.",
      "enter": "{Feld} eingeben",
      "connectorUrl": "Konnektor-URL",
      "connectorUrlNote": "Suche nach Daten innerhalb bestimmter Konnektoren",
      "subModel": "Untermodell",
      "subModelNote": "Passen Sie Ihre Suchergebnisse an Ihren gewünschten Anwendungsfall an",
      "search": "Suche",
      "searchBy": "Suche nach",
      "resetFilters": "Filter zurücksetzen",
      "advancedSearch": "Erweiterte Suche",
      "name": "Name",
      "dct:type": "dct:type",
      "assetId": "Asset-ID"
    },
    "noResult": {
      "title": "Kein Ergebnis",
      "description": "Bitte suchen Sie, um die verfügbaren Datenangebote im Netzwerk zu durchsuchen"
    },
    "helpCard": {
      "title": "Wie funktioniert es?",
      "description": "Entdecken Sie den Datenangebotskatalog anderer Dataspace-Teilnehmer. Sie können im Datenraum nach verfügbaren Datenangeboten suchen, diese auswählen und abonnieren.",
      "subtitle": "Möchten Sie mehr darüber erfahren, wie Datenangebote, Verhandlung und Konsum funktionieren?",
      "documentation": "Dokumentation"
    },
    "offers": {
      "downloadSelected": "Ausgewählter Download",
      "transferSelected": "Ausgewählte übertragen",
      "negotiate": "Verhandeln",
      "noOffer": "Es sind keine Datenangebote verfügbar."
    },
    "offer-details": {
      "title": "Vertragsverhandlungen bestätigen",
      "description": "Beschreibung",
      "details": "Details",
      "attachedPolicies": "Angehängte Richtlinien",
      "termsCheck": "Ich stimme den Vertragsbedingungen zu und möchte die Vertragsverhandlung und den Datenaustausch beginnen.",
      "negotiate": "Verhandeln",
      "negotiateAndDownload": "Verhandeln und herunterladen",
      "negotiateAndTransfer": "Verhandeln und übertragen",
      "transfer": "Übertragen",
      "cancel": "Abbrechen",
      "attribute": "Attribut",
      "value": "Wert",
      "endpointUrl": "Endpunkt-URL",
      "organization": "Organisation",
      "bpnNumber": "BPN-Nummer",
      "manufacturerPartId": "Hersteller-Teile-ID",
      "noOfAssets": "Anzahl der ausgewählten Assets",
      "membership": "Mitgliedschaft",
      "dismantlerBrands": "Erlaubte Marken für Demontage",
      "frameworkAgreement": "Rahmenvereinbarung",
      "dismantler": "Zerlegung",
      "backToAssets": "Zurück zu den Assets",
      "noPolicyMatchTitle": "Assets nicht ausgehandelt, oder Policies nicht identisch",
      "noPolicyMatchText": "Sie versuchen, einige Assets herunterzuladen, die noch nicht verhandelt wurden. Oder einige der Vermögenswerte, über die Sie verhandeln möchten, haben keine identischen Richtlinien. Bitte wählen Sie die richtigen Assets aus und fahren Sie fort.",
      "negotiateInProgress": "Verhandlung und Download laufen",
      "negotiateAndDownloadSuccess": "Verhandlung und Download erfolgreich abgeschlossen",
      "negotiateAndTransferSuccess": "Verhandlung und Übergabe erfolgreich abgeschlossen",
      "transferSuccess": "Übertragung erfolgreich abgeschlossen",
      "progress": "Fortschritt",
      "fetchShell": "Shell holen",
      "exportToCSV": "In CSV exportieren",
      "fetchJobFailed": "Fehler beim Abrufen von Auftragsdetails",
      "negotiateError": "Fehler beim Herunterladen von Assets",
      "dtr": "Register für digitale Zwillinge",
      "edc": "Konnektor-Assets",
      "browseDtr": "DTR durchsuchen"
    },
    "dtr": {
      "title": "Digitale Zwillingsschalen",
      "shells": "Shells durchsuchen",
      "description": "Sie werden automatisch über das Abrufen und Exportieren von Shells aus der Digital Twin Registry des ausgewählten Anbieters verhandeln"
    }
  },
  "assetUploadHistory": {
    "title": "Verlauf des Hochladens von Assets",
    "subtitle": "Diese Historie gibt einen Überblick über die Transaktionen auf den Datenraum-Konnektoren Ihres Unternehmens. Hier sind alle Aktivitäten zu Vermögenswerten, Policen und Vertragsdefinitionen aufgeführt.",
    "refresh": "Aktualisieren",
    "processId": "Prozess-ID",
    "providerUrl": "Anbieter-URL",
    "createdOn": "Erstellt am",
    "totalItems": "Gesamte Artikel",
    "successful": "Erfolgreich",
    "failed": "Fehler fehlgeschlagen",
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "status": "Status",
    "actions": "Aktionen",
    "howItWork": {
      "title": "Wie funktioniert es?",
      "description": "Du kannst den Verlauf all deiner hochgeladenen Assets in verschiedenen Datenräumen finden.  Sie können die Dateien erneut lokal herunterladen oder an einen externen Speicherort übertragen. Im Falle von Fehlern müssen Sie den Download erneut versuchen oder das Datenangebot neu verhandeln.",
      "moreInfo": "Möchtest du mehr über die Upload-Historie erfahren und was du hier alles tun kannst?"
    }
  },
  "assetDownloadHistory": {
    "subtitle": "Die Historie gibt Ihnen einen Überblick über die heruntergeladenen Daten Ihrer Organisation, die aus den ausgehandelten Verträgen im Datenraum verfügbar sind. Bei Bedarf können Sie die Daten erneut aus dieser Verlaufsliste herunterladen.",
    "howItWorks": {
      "description": "Du kannst den Verlauf all deiner heruntergeladenen Assets in verschiedenen Datenräumen finden.  Sie können die Dateien erneut lokal herunterladen oder an einen externen Speicherort übertragen. Im Falle von Fehlern müssen Sie den Download erneut versuchen oder das Datenangebot neu verhandeln.",
      "moreInfo": "Möchten Sie mehr über die Download-Historie erfahren und was Sie hier alles tun können?"
    },
    "downloadError": "Download nicht erfolgreich, bitte versuchen Sie es erneut!",
    "viewErrors": "Fehler anzeigen"
  },
  "digitalTwinBrowser": {
    "subHeading": "Das sind Ihre Digitalen Zwillinge und ihre Untermodelle. Ihre digitalen Zwillinge werden über Ihre Digital Twin Registry dem Datenraum zur Verfügung gestellt.",
    "noDocumentError": "Kein aspectDocument für die aktuelle ID",
    "nameNotProvided": "Name nicht angegeben",
    "fetchDigitalTwinsError": "Fehler beim Abrufen digitaler Zwillinge",
    "fetchAspectDocumentError": "Fehler beim Abrufen des Seitendokuments",
    "fetchAspectModelError": "Fehler beim Abrufen des Aspektmodells",
    "detailsOverviewModalTitle": "Details zum Aspekt",
    "addItem": "Element hinzufügen",
    "detailsTable": {
      "id": "ID",
      "idShort": "ID Kurz",
      "displayName": "Anzeigename",
      "modelUrn": "Modell URN"
    },
    "shellsTable": {
      "id": "ID",
      "name": "Name",
      "manufacturer": "Hersteller-Teile-ID",
      "modifiedBy": "Benutzer",
      "modifiedAt": "Zeit"
    }
  },
  "connector": {
    "addNewConnector": "+ Neuen Connector hinzufügen",
    "searchConnector": "Nach Connector-Namen suchen",
    "connectorModal": {
      "error": "Abrufen der Connector-Details fehlgeschlagen"
    }
  },
  "column": {
    "name": "Name",
    "connectorName": "Connector-Name",
    "contractId": "Vertrags-ID",
    "productId": "Produkt-ID",
    "manufacturerPartId": "Hersteller-Teile-ID",
    "manufacturerId": "Hersteller-ID",
    "digitalTwinType": "Typ des digitalen Zwillings",
    "correlationId": "Korrelations-ID",
    "requestId": "ID der Anfrage",
    "bpn": "BPN",
    "createdAt": "Erstellt am",
    "createdBy": "Erstellt von",
    "attribute": "Attribut",
    "url": "URL",
    "actions": "Aktionen",
    "lastUpdatedTime": "Zeitpunkt der letzten Aktualisierung",
    "status": "Status",
    "requestedDate": "Angefordertes Datum",
    "policyType": "Typ der Richtlinie",
    "modifiedBy": "Geändert von",
    "modifiedOn": "Geändert am",
    "syncStatus": "Status synchronisieren",
    "assetId": "Objekt-ID",
    "assetType": "Asset-Typ",
    "type": "Typ",
    "createdFrom": "Erstellt von",
    "createdTo": "Erstellt bis",
    "statusDuration": "Status/Dauer",
    "certifier": "Zertifizierer",
    "version": "Version",
    "registrationNumber": "Registrierungsnummer",
    "validUntil": "Gültig bis",
    "offerId": "Angebots-ID",
    "errorMessage": "Fehlermeldung",
    "globalAssetId": "Globale Asset-ID",
    "shellName": "Name der Shell",
    "contractAgreementId": "Vertragsvereinbarungs-ID",
    "signingDate": "Unterzeichnungsdatum",
    "providerConnectorUrl": "Provider-Connector-URL",
    "consumerConnectorUrl": "Consumer-Connector-URL",
    "providerBpnl": "Provider-BPNL",
    "consumerBpnl": "Consumer-BPNL",
    "counterPartyId": "Gegenpartei-ID",
    "resourceId": "Ressourcen-ID",
    "resourceType": "Ressourcentyp",
    "transactionMethod": "Transaktionsmethode",
    "trustLevel": "Vertrauensebene"
  },
  "messagesBrowser": {
    "fetchMessagesError": "Fehler beim Abrufen von Nachrichten",
    "openRelatedMessage": "Verwandte Nachricht öffnen",
    "messagesTable": {
      "id": "Id",
      "name": "Name",
      "createdAt": "Erstellt am",
      "createdBy": "Erstellt von",
      "type": "Typ",
      "context": "Kontext",
      "senderBpn": "Absender BPN",
      "receiverBpn": "Empfänger BPN",
      "correlationId": "Korrelations-ID",
      "jobId": "Auftrags-ID",
      "conversationId": "Konversations-ID",
      "status": "Status"
    },
    "messageType": {
      "ecu": "ECU",
      "generic": "Generisch",
      "quality": "Qualität",
      "ccmpush": "CCM Push",
      "ccmrequest": "CCM-Anfrage",
      "ccmstatus": "CCM-Status",
      "ccmavailable": "CCM Verfügbar"
    }
  },
  "bpnSelector": {
    "selectFromList": "Aus Liste auswählen",
    "enterManually": "Geben Sie manuell ein",
    "selectPlaceholder": "Wählen Sie eine Standort-BPN aus",
    "manualPlaceholder": "Geben Sie die BPN ein (z. B. BPNL123456789ABC).",
    "validFormat": "Gültiges BPN-Format",
    "invalidFormat": "Ungültiges BPN-Format",
    "invalidFormatHint": "Format: BPNL + 12 alphanumerische Zeichen",
    "formatHint": "Format: BPNL123456789ABC (insgesamt 16 Zeichen)",
    "selected": "Ausgewählt"
  },
  "searchableSelect": {
    "pressEnterToUse": "Drücken Sie die Eingabetaste, um dieses BPNA/BPNS zu verwenden",
    "placeholderText": "Bitte geben Sie eine gültige BPNA/BPNS ein",
    "placeholder": "Wählen Sie einen BPNA/BPNS aus oder geben Sie ihn ein"
  }
}
